import axios from "axios";

// CSRF トークンは「要求を送る瞬間」に読む（モジュール評価時に読まない）。
// このモジュールは application パック（_head_2019 の <script>。csrf_meta_tags より前に置かれている）から
// 読み込み時に評価されることがあり、その時点では <meta name="csrf-token"> がまだ無い。
// 評価時に [0].content を読むと TypeError でパック全体が止まり、React が一切マウントされなくなる
// （2026-10-25 TGW-3137 のデプロイでイベント編集ページが真っ白になった障害）。
export const csrfToken = () => {
  if (typeof document === "undefined") return "";
  const meta = document.getElementsByName("csrf-token")[0];
  return meta ? meta.content : "";
};

const instance = axios.create({
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
  responseType: "json",
});

instance.interceptors.request.use((config) => {
  config.headers["X-CSRF-Token"] = csrfToken();
  return config;
});

export default instance;
